export const pushHistory = (state) => {
  history.pushState(state, '', '');
};

export const goBack = () => {
  history.back();
};
